import type { Except } from '@festina-life/core'
import { createContext, type ReactElement, useContext } from 'react'

import type { useThemeContext } from './useThemeContext'

export type ProviderProps = {
  isInDebugMode: boolean
  children:
    | ReactElement
    | ((currentContext: UiContextType) => ReactElement | null | false)
}

type UiContextType = Except<ProviderProps, 'children'> &
  ReturnType<typeof useThemeContext>

const context = createContext<UiContextType | null>(null)
const useUiContext = () => useContext(context)
const Provider = context.Provider

export { Provider, useUiContext }
